
import { Box, Divider, Img, Text } from "@chakra-ui/react";

import { India } from "./Data/footerdata";
// import gs12 from "../../Assets/gs12.png";
export const Footer = () => {
  return (
    <Box bgColor={"black"} color={"white"}>
      <Box display={"grid"} fontSize={"13px"} width={"50%"} margin={"auto"}>
        About US &nbsp; &nbsp; &nbsp; UC Impact &nbsp; &nbsp; Terms & Conditions Privacy Policy &nbsp; &nbsp;
        Interest-Based Advertising &nbsp; &nbsp; Anti Discrimination Policy &nbsp; &nbsp; Partner Welfare Policy &nbsp;
        &nbsp; Information Security Policy Statements & Objective &nbsp; &nbsp; Blog &nbsp; &nbsp; Reviews &nbsp;
        &nbsp;Near Me &nbsp; &nbsp; Careers &nbsp; &nbsp; Gift Cards &nbsp; &nbsp; Contact Us &nbsp; &nbsp;Quick Links
      </Box>
      <Divider width={"50%"} m={"auto"} />
      <Box w={"50%"} margin={"auto"}>
        <Text textAlign={"left"}>Serving in</Text>
        <Text textAlign={"left"} fontSize={"10px"}>
          USA
        </Text>
        <Text fontSize={"12px"} textAlign={"left"}>
          Austin&nbsp; &nbsp; Dallas&nbsp; &nbsp; New York City
        </Text>
      </Box>
      <Box width={"50%"} m={"auto"}>
        <Text textAlign={"left"} fontSize={"14px"}>
          IND
        </Text>
        <Text textAlign={"left"} fontSize={"12px"} letterSpacing={"3px"} lineHeight={"30px"}>
          {India.map((e) => e.city + " ")}
        </Text>
      </Box>
      <Box w={"50%"} m={"auto"}>
        <Text textAlign={"left"}>UAE</Text>
        <Text textAlign={"left"} fontSize={"12px"}>
          Abu Dhabi Dubai Sharjah
        </Text>
      </Box>
      <Box w={"50%"} m={"auto"}>
        <Text textAlign={"left"}>SGP</Text>
        <Text textAlign={"left"} fontSize={"12px"}>
          Singapore
        </Text>
      </Box>
      <Box w={"50%"} m={"auto"}>
        <Text textAlign={"left"} fontSize={"10px"}>
          KISA
        </Text>
        <Text textAlign={"left"} fontSize={"12px"}>
          jeddah &nbsp; &nbsp; Riyadh &nbsp; &nbsp;
        </Text>
      </Box>
      <Divider width={"90%"} />

      <Box>
        <Img src="/Images/ghaeseva.png" />
      </Box>
      <Box>
        <Text>© 2014-22 UrbanClap Technologies India Pvt. Ltd.</Text>
      </Box>
      <Box></Box>

    </Box>
  );
};
